import React from "react";
import {FormControl, makeStyles, MenuItem, Select, Typography} from "@material-ui/core";
import './SortingBySelect.css';
import {Done, TrendingFlat} from "@material-ui/icons";

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: 120,
    },
    descMenuItem: {
        borderBottom: "1px solid #ddd"
    },
    descIcon: {
        transform: "rotate(90deg)"
    },
    ascIcon: {
        transform: "rotate(90deg)"
    }
}));

// TODO: Add arrow beside chosen select
const SortingBySelect = (props) => {
    const classes = useStyles();

    const handleChange = (event) => {
        //setValue(event.target.value);
        props.changeSortingCriteria(event.target.value);
    };
    return (
        <FormControl className={classes.formControl}>
            <Select
                value={props.value}
                onChange={handleChange}
                displayEmpty
                disableUnderline={true}
            >
                {props.selectItems.map((item, idx) => {
                    return (
                        item.isFromDevice && item.text === "Recente" ?
                            [
                                <MenuItem key={item.value + "-desc"} className="sorting-menu-item"
                                          value={item.value + ",desc"}>
                                    <div className={`menu-item-with-icon`}>
                                        <Typography variant="body2">Più {item.text}</Typography>
                                        <TrendingFlat style={{transform: "rotate(90deg)"}} fontSize="small"/>
                                    </div>
                                    <div className="d-none sorting-select-icon-right">
                                        <Done fontSize="small"/>
                                    </div>
                                </MenuItem>,
                                <MenuItem key={item.value + "-asc"}
                                          className={idx !== props.selectItems.length - 1 ? classes.descMenuItem + ` sorting-menu-item` : "sorting-menu-item"}
                                          value={item.value + ",asc"}>
                                    <div className="menu-item-with-icon">
                                        <Typography variant="body2">Meno {item.text}</Typography>
                                        <TrendingFlat style={{transform: "rotate(90deg)"}} fontSize="small"/>
                                    </div>
                                    <div className="d-none sorting-select-icon-right">
                                        <Done fontSize="small"/>
                                    </div>
                                </MenuItem>
                            ]
                            :
                            [
                                <MenuItem key={item.value + "-desc"} className="sorting-menu-item"
                                          value={item.value + ",desc"}>
                                    <div className={`menu-item-with-icon`}><Typography
                                        variant="body2">{item.text}</Typography> <TrendingFlat
                                        style={{transform: "rotate(90deg)"}} fontSize="small"/></div>
                                    <div className="d-none sorting-select-icon-right"><Done fontSize="small"/></div>
                                </MenuItem>,
                                <MenuItem key={item.value + "-asc"}
                                          className={idx !== props.selectItems.length - 1 ? classes.descMenuItem + ` sorting-menu-item` : "sorting-menu-item"}
                                          value={item.value + ",asc"}>
                                    <div className="menu-item-with-icon">
                                        <Typography variant="body2">{item.text}</Typography>
                                        <TrendingFlat fontSize="small" style={{transform: "rotate(-90deg)"}}/>
                                    </div>
                                    <div className="d-none sorting-select-icon-right">
                                        <Done fontSize="small"/>
                                    </div>
                                </MenuItem>
                            ]

                    )
                })}

            </Select>
        </FormControl>
    )
}
export default SortingBySelect;
